(function($) {
    'use strict';


	/**
	* Initiate independent functions
	*/
	function fnInit() {

		$( 'header.primary' ).each( fnNavigationPrimary );						// Header navigation
		$( 'header.home-hero' ).each( fnHomeHero );								// Home hero
        $( '.dismissible-message' ).each( fnDismissibleMessage );				// Dismissible header message
		$( 'body' ).on( 'click', 'a.hash-link', fnScrollToID );					// Smooth anchor links
		$( '.lazy' ).each( fnLazyLoad );										// Lazyload images
		fnInViewDetect();														// Adds in view detection
        $( '.paroller, [data-paroller-factor]' ).each( fnParallax );            // Paroller (parallax)
		$( 'header.hero nav.hero-menu' ).each( fnHeroSubMenu );			        // Hero sub-menu
		$( 'nav.flex-menu' ).each( fnHeroSubMenu );
		$( 'section.media-text-banners' ).each( fnMediaTextBanners );			// Media text banners
		$( 'section.product-carousel-tabs, section.product-info-tabs' ).each( fnAccordionTabs ); // Accordions on mobile, tabs on desktop
		$( 'section.product-carousel-tabs' ).each( fnProductCarouselTabs );	    // Tabbed product carousels
		$( 'section.testimonial-carousel' ).each( fnTestimonialCarousel );		// Testimonial carousel
		$( 'header.product-hero' ).each( fnProductHero );			            // Product hero
		$( 'section.video-banner' ).each( fnVideoBanner );			            // Video banner
        $( '.dropkick select' ).dropkick({ mobile: true });                     // Select drop-down styling (Dropkick.js)
        $( 'section.location-finder' ).each( fnStoreFinder );				    // Store locator
        $( 'section.downloads' ).each( fnDownloadFilters );                     // Download filters
        $( 'nav.casestudies,nav.blog' ).each( fnArchiveFilters );               // Download filters
        $( 'section.faq-list' ).each( fnFaqList );                     			// FAQ List
		fnConnectionSpeedClasses();												// Adds connection speed classes to the url
		fnShowBrowserVersion();													// Outputs the browser version into the console for testing
        $( 'body' ).addClass( 'page-loaded' );                                  // Runs when the page is loaded

        /**
        * After Gravity Form submission
        */
        $( document ).on( 'gform_post_render', function() {
        	$( 'section.form-large' ).each( fnFormLarge );                     	// Form large
		    $( '.dropkick select' ).dropkick({ mobile: true });                 // Select drop-down styling (Dropkick.js)
		} );

	}
    fnInit();


}(jQuery));
